import styled from 'styled-components'

const PathsStyle = styled.div`
	--arrowMarginLeftRight: var(--sp2x);
	--arrowSizes: var(--sp2x);

	position: relative;

	&.hero-section {
		&::after {
			display: none;
		}
	}

	.scroll-wrap {
		display: flex;
		align-items: center;
		position: relative;
		white-space: nowrap;
		overflow: scroll hidden;
		-ms-overflow-style: none;
		scrollbar-width: none;

		::-webkit-scrollbar {
			display: none;
			-ms-overflow-style: none;
			scrollbar-width: none;
		}

		.path-name {
			white-space: nowrap;
		}

		.arrow-right {
			display: flex;
			margin: 0 var(--arrowMarginLeftRight);
			font-size: var(--arrowSizes);
		}
	}

	&::after {
		content: '';
		position: absolute;
		right: 0;
		top: 0;
		width: 50px;
		height: 100%;
		background: linear-gradient(270deg, var(--secondaryColor1) 0, hsla(0, 0%, 100%, 0));
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--arrowMarginLeftRight: var(--sp1-5x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--arrowMarginLeftRight: var(--sp1x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--arrowMarginLeftRight: var(--sp1x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--arrowMarginLeftRight: var(--sp1x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--arrowMarginLeftRight: var(--sp1x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--heroBtnPadding: var(--sp1-5x) var(--sp3x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--arrowMarginLeftRight: var(--sp1x);
		--arrowSizes: var(--sp1-5x);
	}
`

export default PathsStyle
